import { DocumentType } from 'shared/domains/apollo/generated/types';
import { isDocxDocument } from '../isDocxDocument';
import { isPdfDocument } from '../isPdfDocument';
import { isSentForSigning } from '../isSentForSigning';
import { PreviewTypes } from '../types';
export function getPreviewType(document) {
    const isFreeText = document.type === DocumentType.Freetext;
    const isComposed = document.type === DocumentType.Composed;
    const sentForSigning = isSentForSigning(document);
    const docxDocument = isDocxDocument(document);
    const pdfDocument = isPdfDocument(document);
    if (sentForSigning) {
        return PreviewTypes.PDF;
    }
    if (isFreeText) {
        return PreviewTypes.FREE_TEXT;
    }
    if (isComposed) {
        return PreviewTypes.COMPOSED;
    }
    if (docxDocument) {
        return PreviewTypes.DOCX;
    }
    if (pdfDocument) {
        return PreviewTypes.PDF;
    }
    return PreviewTypes.UNKNOWN;
}
